import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';
// Components
import Tag from '../../atoms/Tag/Tag';
// Styles
import styles from './ArticleHeading.module.css';

function ArticleHeading({
  image, title, category,
}) {
  return (
    <header className={styles.header}>
      {image ? (
        <div className={styles.image}>
          <Image
            src={image.url}
            alt={image?.description}
            fill
            sizes="75vw"
            priority
          />
        </div>
      ) : null}
      {category
        ? (
          <Link className={styles.category} href={category.href}>
            <Tag outlined content={category.label} />
          </Link>
        )
        : null}
      <h1 className={styles.title}>{title}</h1>
    </header>
  );
}

ArticleHeading.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
  category: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }),
};

ArticleHeading.defaultProps = {
  image: null,
  category: null,
};

export default ArticleHeading;
